import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input, InputProps } from '../ui/input';
import { cn } from '../../lib/utils';

interface IProps extends InputProps {
  name: string;
  label?: string;
  required?: boolean;
}

export default function CardExpiryInputField({
  name,
  label,
  required,
  disabled,
  inputClassName,
  ...inputProps
}: IProps) {
  const { control } = useFormContext();

  const formatExpiry = (value: string = '') => {
    const digitsOnly = value.replace(/\D/g, '').slice(0, 4);
    if (digitsOnly.length >= 1) {
      let month = digitsOnly.slice(0, 2);
      if (parseInt(month, 10) > 12) {
        month = '12';
      }
      if (digitsOnly.length >= 3) {
        return `${month}/${digitsOnly.slice(2, 4)}`;
      }
      return month;
    }
    return digitsOnly;
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className="w-fit">
          {label && (
            <FormLabel
              className={cn(
                'transition-all text-body-base-regular',
                fieldState.error && 'text-error',
                !fieldState.error && field.value && 'text-muted-foreground'
              )}
            >
              {required && (
                <span className="text-red-500 dark:text-red-900">*</span>
              )}
              {label}
            </FormLabel>
          )}
          <FormControl>
            <Input
              {...inputProps}
              value={formatExpiry(field.value)}
              onChange={e => {
                const raw = e.target.value.replace(/\D/g, '').slice(0, 4);
                const formatted = formatExpiry(raw);
                field.onChange(formatted);
              }}
              disabled={disabled}
              inputClassName={inputClassName}
              inputMode="numeric"
              maxLength={5} // e.g. 12/26
              placeholder="MM/YY"
              className={cn(
                'shadow-none bg-fill-base rounded-xl tracking-widest',
                fieldState.error
                  ? 'border-2 border-red-500'
                  : field.value
                    ? 'border border-success'
                    : 'border border-border placeholder:text-body-base-regular',
                inputProps.className
              )}
            />
          </FormControl>
          <FormMessage className="text-red-500" />
        </FormItem>
      )}
    />
  );
}
